<template>
  <div class="coffee">
     <div style="width:100%;height:64px;"></div>
    <el-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/banner.jpg"
      mode="contain"
    ></el-image>
    <el-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p1.jpg"
      mode="contain"
      style="margin-top: -5px"
    ></el-image>
    <div style="background: #f2eeed; margin-top: -6px">
      <buttongroup></buttongroup>
    </div>
    <div style="width: 100%; height: 60px; background: #f2eeed"></div>
    <el-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p2.jpg"
      style="margin-top: -6px"
    ></el-image>
    <div class="p1" style="height: 900px">
      <bigtitle title="学调酒为什么选择成都欧米奇"></bigtitle>
      <middletitle title="四大优势"></middletitle>
      <div style="width: 100%; height: 30px"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="中外名师授课" name="1">
          <el-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p3-1.jpg"
            style="margin-top: -6px"
          ></el-image>
        </el-tab-pane>
        <el-tab-pane label="就业指导" name="2">
          <el-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p3-2.jpg"
            style="margin-top: -6px"
          ></el-image>
        </el-tab-pane>
        <el-tab-pane label="创业帮扶" name="3">
          <el-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p3-3.jpg"
            style="margin-top: -6px"
          ></el-image>
        </el-tab-pane>
        <el-tab-pane label="技能+学历" name="4">
          <el-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p3-4.jpg"
            style="margin-top: -6px"
          ></el-image>
        </el-tab-pane>
      </el-tabs>
      <div style="width: 100%; height: 20px"></div>
      <buttongroup></buttongroup>
    </div>
    <div class="p2" style="background: #f2eeed; height: 1000px">
         <bigtitle title="名师教学"></bigtitle>
      <middletitle title="TEACHING BY FAMOUS TEACHER"></middletitle>
      <div style="width: 100%; height: 24px"></div>
      <el-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p4.jpg"
        style="margin-top: -6px"
      ></el-image>
    </div>
    <el-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p5.jpg"
      style="margin-top: -6px"
    ></el-image>
    <el-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/wine/p6.jpg"
      style="margin-top: -6px"
    ></el-image>
    <div style="background: #f2eeed; margin-top: -6px; padding: 0 0 53px 0">
      <buttongroup></buttongroup>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    buttongroup: () => import("@/components/common/buttongroup"),
    bigtitle: () => import("@/components/common/bigTitle"),
    middletitle: () => import("@/components/common/middletitle"),
  },
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      activeName: "1",
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs__item {
  font-size: 28px;
  font-weight: 600;
  width: 300px;
}
/deep/ .el-tabs__item:hover {
  color: #8d6e63;
}
/deep/ .el-tabs__item.is-active {
  color: #fff;
  background: #8d6e63;
}
/deep/ .el-tabs__active-bar {
  height: 0;
  background-color: #fff;
}
/deep/ .el-tabs__item {
  color: #838383;
  height: 53px;
  line-height: 53px;
  padding: 0 18px;
}
.coffee {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.p1 {
  width: 1200px;
  margin: auto;
  text-align: center;
  height: 100%;
  padding: 36px 0;
}
.p2 {
  width: 100%;
  text-align: center;
  height: 100%;
  margin: auto;
  padding: 36px 0;
}
</style>